var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUfcGymLogoRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 16",
    style: {
      enableBackground: "new 0 0 64 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D22108;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#D22108;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UFC_GYM_Horz_RGB_00000102527270580431153320000012980297288419374482_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.1,11.7h-0.8l-0.2-0.5c-0.3,0.4-0.9,0.6-1.6,0.6h-1.1c-1.1,0-1.6-0.4-1.6-1.2c0-0.2,0-0.5,0.1-0.8l1-3.7 c0.2-0.7,0.5-1.2,0.9-1.5c0.4-0.3,1-0.5,1.7-0.5h1.5c0.5,0,0.9,0.1,1.2,0.3c0.3,0.2,0.4,0.5,0.4,0.9c0,0.2,0,0.4-0.1,0.7 l-0.1,0.6h-1.4l0.1-0.5c0-0.1,0-0.2,0-0.4c0-0.2,0-0.3-0.2-0.3c-0.1-0.1-0.3-0.1-0.5-0.1h-0.9c-0.3,0-0.6,0.1-0.7,0.2 c-0.2,0.1-0.3,0.4-0.4,0.7l-1,3.4c0,0.2-0.1,0.3-0.1,0.5c0,0.2,0,0.3,0.2,0.3c0.1,0.1,0.3,0.1,0.5,0.1h1c0.3,0,0.6-0.1,0.7-0.2 c0.2-0.1,0.3-0.4,0.4-0.7l0-0.2l0.2-0.6h-1.4l0.3-1.2h2.8L46.1,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.3,4.2C50.6,5.6,50.8,6.9,51,8c0.8-1.1,1.7-2.4,2.7-3.8h1.7l-4,5.2l-0.7,2.4h-1.4L50,9.3l-1.1-5.1 C48.9,4.2,50.3,4.2,50.3,4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.1,7.8c0-0.9,0-1.6,0-2l-1.6,6H54l2.1-7.6h2.1c0,2.4,0.1,4.2,0.1,5.3v0.8c0.7-1.3,1.9-3.4,3.5-6.2H64 l-2.1,7.6h-1.4l1.7-6c-0.8,1.5-1.9,3.5-3.4,6h-1.6C57.1,10.6,57.1,9.3,57.1,7.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "26.2,4.2 16.2,4.2 17,1.2 27,1.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "19.4,9.2 24.8,9.2 25.6,6.2 15.7,6.2 13.3,14.7 17.9,14.7  "
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.7,11.6c-0.1-0.1-0.2-0.1-0.2-0.3c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1l1.8-6.5c0-0.2,0.1-0.3,0.3-0.4 c0.1-0.1,0.3-0.1,0.7-0.1h5l0.8-3h-7c-1.3,0-2.2,0.1-2.7,0.4c-0.5,0.3-0.9,0.8-1.1,1.6l-2.6,9.3c0,0.1,0,0.3-0.1,0.4 c0,0.1,0,0.3,0,0.4c0.1,0.4,0.4,0.8,0.9,1.1c0.5,0.3,1.1,0.4,1.7,0.4h7.3l0.8-3h-5.3C31,11.7,30.8,11.7,30.7,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.2,1.2L0.1,12.4C0,12.6,0,12.7,0,12.9s0,0.3,0,0.4c0.1,0.4,0.4,0.8,0.9,1.1c0.5,0.3,1.1,0.4,1.7,0.4h5.2 c1.3,0,2.2-0.1,2.7-0.4c0.5-0.3,0.9-0.8,1.1-1.6l3.2-11.6h-4.6L7.5,11.3c0,0.2-0.1,0.3-0.3,0.4s-0.3,0.1-0.7,0.1H5.7 c-0.2,0-0.3,0-0.4-0.1c-0.1-0.1-0.2-0.1-0.2-0.3c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1l2.7-10H3.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "61.5,13.2 40.1,13.2 39.7,14.7 61.1,14.7  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUfcGymLogoRed);
export default __webpack_public_path__ + "static/media/ufc-gym-logo-red.7441ed61ccf22932cb7798991b8172e2.svg";
export { ForwardRef as ReactComponent };